import React from 'react';
import { MdFlag, MdStar, MdVisibility, MdPeople } from 'react-icons/md';

const About = () => {
    return (
        <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', backgroundColor: '#121212', color: '#e0e0e0' }}>
            <header style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h1 style={{ fontSize: '2.5em', color: '#e0e0e0' }}>About Omni Trade Beacon</h1>
            </header>

            <section style={{ margin: '0 auto', padding: '0 20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <MdFlag style={{ fontSize: '2em', color: '#e0e0e0', marginRight: '10px' }} />
                    <h2 style={{ fontSize: '2em', color: '#e0e0e0' }}>Our Mission</h2>
                </div>
                <p style={{ fontSize: '1.2em', color: '#b0b0b0', lineHeight: '1.6' }}>
                    At Omni Trade Beacon, our mission is to guide you through the top platforms for trading stocks and cryptocurrencies. We aim to provide comprehensive insights and reviews on leading trading platforms to help you make informed investment decisions.
                </p>

                <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px', marginBottom: '15px' }}>
                    <MdStar style={{ fontSize: '2em', color: '#e0e0e0', marginRight: '10px' }} />
                    <h2 style={{ fontSize: '2em', color: '#e0e0e0' }}>What We Offer</h2>
                </div>
                <p style={{ fontSize: '1.2em', color: '#b0b0b0', lineHeight: '1.6' }}>
                    We offer detailed reviews and comparisons of popular trading platforms such as Binance, Coinbase, Robinhood, and others. Our platform is designed to provide you with the latest information, features, and benefits of each platform, ensuring you choose the best one for your trading needs.
                </p>

                <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px', marginBottom: '15px' }}>
                    <MdVisibility style={{ fontSize: '2em', color: '#e0e0e0', marginRight: '10px' }} />
                    <h2 style={{ fontSize: '2em', color: '#e0e0e0' }}>Our Vision</h2>
                </div>
                <p style={{ fontSize: '1.2em', color: '#b0b0b0', lineHeight: '1.6' }}>
                    Our vision is to become the premier resource for trading platforms, known for our thorough research and unbiased reviews. We strive to stay at the forefront of the trading industry and continuously update our content to reflect the latest trends and changes.
                </p>

                <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px', marginBottom: '15px' }}>
                    <MdPeople style={{ fontSize: '2em', color: '#e0e0e0', marginRight: '10px' }} />
                    <h2 style={{ fontSize: '2em', color: '#e0e0e0' }}>Our Team</h2>
                </div>
                <p style={{ fontSize: '1.2em', color: '#b0b0b0', lineHeight: '1.6' }}>
                    Our team is passionate about trading and dedicated to providing valuable insights into the best trading platforms. With expertise in finance and technology, we work diligently to ensure that our content helps you navigate the trading landscape effectively.
                </p>
            </section>

            <footer style={{ textAlign: 'center', padding: '20px 0', borderTop: '1px solid #333', marginTop: '30px' }}>
                <p style={{ fontSize: '1em', color: '#b0b0b0' }}>© 2024 Omni Trade Beacon. All Rights Reserved.</p>
            </footer>
        </div>
    );
}

export default About;
